
(function($) {
function windowHeight() {
    var  windowHeight = window.innerHeight;
       return windowHeight;
 }
 document.documentElement.style.setProperty('--window-height', windowHeight()+'px');

			 $(window).resize(debounce(function() {
               document.documentElement.style.setProperty('--window-height', windowHeight()+'px');
            },50));

function headerHeight() {
    var  headerHeight = $('.site-header').outerHeight() +$('.announcement-bar').outerHeight();
       return headerHeight;
 }
 document.documentElement.style.setProperty('--header-height', headerHeight()+'px');

			 $(window).resize(debounce(function() {
                document.documentElement.style.setProperty('--header-height', headerHeight()+'px');
            },50));
})(jQuery);
/***************** SLIDER ******************/
 if ($('.general-slider').length) {
    $('.general-slider').each(function () {
        var slider = $(this);
      	var slideContainer = slider.closest('.slider-container');
        var arrows = slider.data('arrows');
        var dots =  slider.data('dots');
  
       
     slider.flickity({
            groupCells: true,
            contain: true,
            cellAlign: 'left',
            prevNextButtons: arrows,
            pageDots: dots,
       });


    
    // END EACH
    });
}




/***************** TOGGLES *******************/
$('[data-toggle]').on('click',function(e) {
  e.preventDefault();
  var target = $(this).data('target');
  $(this).toggleClass('active');
  $('[data-content="'+target+'"]').slideToggle();
});
 
$('[data-tab-target]').on('click',function(e) {
  e.preventDefault();
  var clickTarget = $(this);
  var target = $(this).data('tab-target');
  var parentDiv = clickTarget.parents('div');
  var parentContentDiv = $('[data-tab-content="'+target+'"]').parents('div');

  parentDiv.find('[data-tab-target]').removeClass('active');
  parentContentDiv.find('[data-tab-content]').removeClass('active');

  clickTarget.addClass('active');
  $('[data-tab-content="'+target+'"]').addClass('active');

});

 

// restyle recharge widget
$( ".rc_select" ).wrap( "<div class='style-select'></div>" );
$( ".rc_label__deliver_every .style-select" ).append( "<img src='https://cdn.shopify.com/s/files/1/0107/3011/1040/files/down-chev.ee9c5771.svg?v=1662858551' alt='' class='' style='margin-right: 5px;'>" );
$(".rc_label__delivery").hide();
$('#rc_autodeliver_options option').prepend("Every");



// results for calc 
$('.Results .tab a').on('click', function (e) {
  e.preventDefault();
  
  $(this).parent().addClass('active');
  $(this).parent().siblings().removeClass('active');
  
  target = $(this).attr('href');

  $('.tab-content > div').not(target).hide();
  
  $(target).fadeIn(600);
  
});

// sticky header

// $(window).scroll(function() {    
//     var scroll = $(window).scrollTop();

//      //>=, not <=
//     if (scroll >= 48) {
//         $(".site-header").addClass("sticky-header");
//     }

//     if (scroll < 48) {
//         $(".site-header").removeClass("sticky-header");
//     }
// });  

// URL PARAMETERS
function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};


if($('[data-tab-target]').length) {
  var currentTab = getUrlParameter('tab');
  $('[data-tab-target="'+currentTab+'"]').click();
 }
 

 /************ Smooth Scroll to Anchor With OFFSET JQUERY VERSION  ****************/
$('a[href*="#"]:not([href="#"], .no-scroll)').click(function () {
  var offset = -$('header').height();
  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top + offset
      }, 500);
      return false;
    }
  }
});